// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"RaZvzWiSqmtmOjeTtYR6G","title":"_2HCLXa49gWiyMBSljIAbPI","icon":"J4WS_LHamRxwwwYc63atH","warningIcon":"_3Z40E9sa2Wbpx4MvJQAhY4","successIcon":"tIQErSCJSrbY7GJK2SSrC","errorWrapper":"ECL2nWx3mdnzA-kA9ZC0Z","errorButtonLink":"nWulZrSx-7vvYH02xvSVI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewEventsTable/Rows/row.less
// module id = 207
// module chunks = 0